import { mixinComponents } from 'assets/js/mixins/components';
import { mixinComputedDebug } from 'assets/js/mixins/computed';
import { mixinDirectives } from 'assets/js/mixins/directives';
import { mixinFilters } from 'assets/js/mixins/filters';
import { mixinMethods } from 'assets/js/mixins/methods';
import { mixinProps } from 'assets/js/mixins/props';
import { mixinWatchDebug } from 'assets/js/mixins/watch';

// Pipe through.
export const MixinComponents = mixinComponents;
export const MixinComputedDebug = mixinComputedDebug;
export const MixinDirectives = mixinDirectives;
export const MixinFilters = mixinFilters;
export const MixinMethods = mixinMethods;
export const MixinProps = mixinProps;
export const MixinWatchDebug = mixinWatchDebug;
